webpackJsonp([70],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/index.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"mds": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"title": "It was great having you!",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/success/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-elixir/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Get started with your favorite technology",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/choose/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-elixir/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-elixir/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-elixir/4-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-elixir/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Create and Retrieve Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/5-create-and-retrieve-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Auth Endpoints",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/7-auth-endpoints/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/10-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Logged in User",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/8-logged-in-user-object/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/6-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/12-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Alternative approaches to schema development",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/11-alternative-approaches/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Database",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-go/4-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connectors",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/4-connectors/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/6-more-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/7-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Query",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/2-a-simple-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Mutation",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/3-a-simple-mutation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Subscriptions",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Adding a Database",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/4-adding-a-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting The Server and Database with Prisma Client",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/5-connecting-server-and-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-java/9-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/6-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime GraphQL Subscriptions",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering, Pagination & Sorting",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-js/8-filtering-pagination-and-sorting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Links and Voting",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/5-links-and-voting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relay",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-python/9-relay/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Nodes",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/5-connecting-nodes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Handling Arguments",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/3-handling-arguments/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "The first query",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/2-preparing-first-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deferred Resolvers",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/4-deferred-resolvers/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Custom Scalars",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/5-custom-scalars/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Interfaces",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/6-interfaces/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/8-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-ruby/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/9-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relations",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/graphql-scala/7-relations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Mutation",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/3-a-simple-mutation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting The Server and Database with Prisma Client",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/5-connecting-server-and-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Adding a Database",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/4-adding-a-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/6-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying to Production",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/9-deployment/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Project Setup",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/1-project-setup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering, Pagination & Sorting",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/10-filtering-pagination-and-sorting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Voting and Custom GraphQL Scalars",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/7-voting-and-scalars/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering, Pagination & Sorting",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/8-filtering-pagination-and-sorting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Creating a GraphQL Server",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/3-graphql-server/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Query",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-apollo/2-a-simple-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/2-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Query",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/4-a-simple-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Mutation",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/5-a-simple-mutation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": 5,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting The Server and Database with Prisma Client",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/7-connecting-server-and-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": 4,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Adding a Database",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/6-adding-a-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/8-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading link-items",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime GraphQL Subscriptions",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/typescript-helix/9-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/angular-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/8-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Navigation",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/4-navigation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/react-apollo/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": 4,
								"videoId": "9_pIJAnpJQM"
							},
							"fields": {
								"slug": "/react-relay/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/ember-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/react-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": 14,
								"videoId": "I6I2Y-t7tGI"
							},
							"fields": {
								"slug": "/react-relay/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"duration": 17,
								"videoId": "zrUfWvPs1RA"
							},
							"fields": {
								"slug": "/react-relay/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"duration": 10,
								"videoId": "eIsctkVmq4Y"
							},
							"fields": {
								"slug": "/react-relay/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"duration": 5,
								"videoId": "xmaDSTXeN54"
							},
							"fields": {
								"slug": "/react-relay/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/react-relay/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"duration": 14,
								"videoId": "yfercdQVFFk"
							},
							"fields": {
								"slug": "/react-relay/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": 18,
								"videoId": "f0Mf2YyGdqc"
							},
							"fields": {
								"slug": "/react-relay/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"duration": 12,
								"videoId": "PdSy5KzuAV0"
							},
							"fields": {
								"slug": "/react-relay/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with Subscriptions",
								"duration": 18,
								"videoId": "2wkILJLcoDs"
							},
							"fields": {
								"slug": "/react-relay/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination and Cache Updates",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/7-pagination-and-cache-updates/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Queries",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/6-more-mutations-and-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/react-urql/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"duration": 0,
								"videoId": ""
							},
							"fields": {
								"slug": "/react-urql/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/vue-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Clients",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/advanced/0-clients/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Server",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/advanced/1-server/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Tooling and Ecosystem",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/advanced/3-tooling-and-ecosystem/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More GraphQL Concepts",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/advanced/2-more-graphql-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Common Questions",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/advanced/5-common-questions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "GraphQL is the better REST",
								"duration": 12,
								"videoId": "T571423fC68"
							},
							"fields": {
								"slug": "/basics/1-graphql-is-the-better-rest/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Security",
								"duration": null,
								"videoId": null
							},
							"fields": {
								"slug": "/advanced/4-security/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Big Picture (Architecture)",
								"duration": 10,
								"videoId": "b7tMHnxzK34"
							},
							"fields": {
								"slug": "/basics/3-big-picture/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Core Concepts",
								"duration": 15,
								"videoId": "NeQfq0U5LnI"
							},
							"fields": {
								"slug": "/basics/2-core-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"duration": 5,
								"videoId": "oCT4HOJsUZQ"
							},
							"fields": {
								"slug": "/basics/0-introduction/"
							}
						}
					}
				]
			}
		},
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---index-daaf6b39c3c1430dae7f.js